export const ChevronRightIcon = (): JSX.Element => (
   <svg width='5' height='8' viewBox='0 0 5 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
         d='M0.749995 0.749791L3.8713 3.87109L0.749995 6.9924'
         stroke='#1A5B31'
         strokeWidth='1.5'
         strokeLinecap='round'
         strokeLinejoin='round'
      />
   </svg>
);
